import http from 'axios'
import { mapGetters, mapActions } from 'vuex'

const BASE_PATH = '/api/'

export const initialState = () => ({
	loaded: false,
	versions: {
		client: {
			version: 0,
			hostname: ''
		},
		server: {
			version: 0,
			hostname: ''
		}
	},
	timestamp: '',
	mediaQuery: 'wide',
	focus: false,
	display: {
		header: false,
		nav: false,
		footer: false,
		layout: 'default'
	},
	cookie: null
})

export const getterTypes = {
	appLoaded: 'appLoaded',
	appVersions: "appVersions",
	appEnv: "appEnv",
	appEnvDev: "appEnvDev",
	appEnvProduction: "appEnvProduction",
	appMediaQuery: 'appMediaQuery',
	appTimestamp: 'appTimestamp',
	appDisplay: 'appDisplay',
	appFocus: 'appFocus',
	appCookieAllowed: 'appCookieAllowed',
	appCookieUnset: 'appCookieUnset'
}

export const actionTypes = {
	appSetLoaded: 'appSetLoaded',
	appVersionsLoad: "appVersionsLoad",
	appMediaQueryInit: 'appMediaQueryInit',
	appSetDisplay: 'appSetDisplay',
	appSetFocus: 'appSetFocus',
	appSetCookie: 'appSetCookie'
}

export const mutationTypes = {
	APP_LOADED: 'APP_LOADED',
	APP_VERSIONS: "APP_VERSIONS",
	APP_MEDIA_QUERY_MODE: 'APP_MEDIA_QUERY_MODE',
	APP_DISPLAY: 'APP_DISPLAY',
	APP_FOCUS: 'APP_FOCUS',
	APP_COOKIE: 'APP_COOKIE'
}

const getters = {
	[getterTypes.appLoaded]: state => state.loaded,
	[getterTypes.appVersions]: state => state.versions,
	[getterTypes.appEnv]: () => process.env.NODE_ENV,
	[getterTypes.appEnvDev]: () => process.env.NODE_ENV !== 'production',
	[getterTypes.appEnvProduction]: () => process.env.NODE_ENV === 'production',
	[getterTypes.appMediaQuery]: state => state.mediaQuery,
	[getterTypes.appTimestamp]: state => state.timestamp,	
	[getterTypes.appDisplay]: state => state.display,
	[getterTypes.appFocus]: state => state.focus,
	[getterTypes.appCookieAllowed]: state => !!state.cookie,
	[getterTypes.appCookieUnset]: state => state.cookie === null
}

const actions = {
	[actionTypes.appSetLoaded]({ commit }) {
		commit(mutationTypes.APP_LOADED)
	},
	[actionTypes.appVersionsLoad]({ commit }, callBackend = true) {
		if (localStorage['app.cookie'] !== undefined)
			commit(mutationTypes.APP_COOKIE, !!localStorage['app.cookie'])
		const endpoints = [
			http.get(`/version.txt`),
			http.get(`/timestamp.txt`)			
		]
		if (callBackend)
			endpoints.push(http.get(BASE_PATH + `ping`))
		return Promise.all(endpoints)
			.then(res => commit(mutationTypes.APP_VERSIONS, res))
	},
	[actionTypes.appMediaQueryInit]({ commit }) {
		const query = window.matchMedia('(max-width:900px)')
		commit(mutationTypes.APP_MEDIA_QUERY_MODE, query.matches ? 'narrow' : 'wide')
		query.addListener(function(temp) {
			commit(mutationTypes.APP_MEDIA_QUERY_MODE, temp.matches ? 'narrow' : 'wide')
		})			
	},
	[actionTypes.appSetDisplay]({ commit }, v) {		
		commit(mutationTypes.APP_DISPLAY, v)
	},
	[actionTypes.appSetFocus]({ commit }, v) {		
		commit(mutationTypes.APP_FOCUS, v)
	},
	[actionTypes.appSetCookie]({ commit }, v) {		
		commit(mutationTypes.APP_COOKIE, v)
	},
}

const mutations = {
	[mutationTypes.APP_LOADED]: state => {
		state.loaded = true
	},
	[mutationTypes.APP_VERSIONS]: (state, params) => {
		state.versions = {
			client: {
				version: params[0].data,
				hostname: location.host
			}			
		}
		state.timestamp = params[1].data
		if (params.length == 3)
			state.versions.server = {
				version: params[2].data.version,
				hostname: params[2].data.hostname
			}
	},
	[mutationTypes.APP_MEDIA_QUERY_MODE]: (state, mode) => {
		state.mediaQuery = mode
	},
	[mutationTypes.APP_DISPLAY]: (state, v) => {
		state.display = v
	},
	[mutationTypes.APP_FOCUS]: (state, v) => {
		state.focus = v
	},
	[mutationTypes.APP_COOKIE]: (state, v) => {
		state.cookie = v
		if (v === true)
			localStorage.setItem('app.cookie', v)
	}
}

export const appComputed = mapGetters(Object.keys(getterTypes));
export const appMethods = mapActions(Object.keys(actionTypes));

export default {
	state: initialState,
	getters,
	actions,
	mutations
}
